// extracted by mini-css-extract-plugin
module.exports = {"switchButton":"SwitchButton_switchButton__hJiA6","checkbox":"SwitchButton_checkbox__2dWM0","active":"SwitchButton_active__3qVgL"};